import {autoImplement} from '@/util';
import moment from 'moment';
import Picklist from './Picklist';
import {ApiPosition} from './Position';
import {ApiSuggestionPosition} from './SuggestionPosition';

export interface ApiSuggestion {
  BuchungNr: number;
  LieferantNr: number;
  ErstelltAm: string;
  ErstelltDurch: string;
  Erledigt: boolean;
  BestellVorschlagPositionen: ApiSuggestionPosition[];
}

export interface SuggestionFilters {
  BuchungNr?: number;
  Erledigt?: boolean;
  ErstelltAm$From?: string;
  ErstelltAm$To?: string;
  ErstelltDurch?: string;
}

export interface DetailSuggestionFilters {
  BuchungNr?: number;
}

interface SuggestionInterface extends ApiSuggestion {
}

export default class Suggestion extends autoImplement<SuggestionInterface>() {
  static fromApi(apiSuggestion: ApiSuggestion): Suggestion {
    return new Suggestion({
      ...apiSuggestion,
    });
  }

  static fromPicklist(picklist: Picklist, BestellVorschlagPositionen: ApiSuggestionPosition[]): Suggestion {
    return new Suggestion({
      BuchungNr: picklist.BestellNr ?? 0,
      LieferantNr: picklist.LieferantenNr ?? 0,
      ErstelltAm: picklist.ErstelltamParsed.toISOString(),
      ErstelltDurch: picklist.Kmsbediener ?? 'SYS',
      Erledigt: picklist.done ?? false,
      BestellVorschlagPositionen,
    });
  }

  get DatumParsed() {
    return moment(this.ErstelltAm);
  }

  get date() {
    return this.DatumParsed.format('L');
  }

  get time() {
    return this.DatumParsed.format('LT');
  }

  get statusColor() {
    return this.Erledigt ? 'error' : 'success';
  }

  get convertedPositions(): ApiPosition[] {
    const originalPositions = this.BestellVorschlagPositionen ?? [];
    return originalPositions.map((position): ApiPosition => {
      return {
        Posnr: position.PosNr,
        Artikelnr: position.ArtikelNr,
        ArtikelArt: position.ArtikelArt,
        Bezeichn1: position.ArtikelBezeichnung1,
        Bezeichn2: position.ArtikelBezeichnung2,

        Menge: 0,
        Einheit: 'Stk',
        Eancode: position.EANCode,

        Gebindemenge: 0,
        Gebindeinh: 'Gebinde',
        Gebinhalt: position.GebindeMenge > 0 ? position.Menge / position.GebindeMenge : null,
        GebindeSchluessel: 0,
        // eslint-disable-next-line camelcase
        EAN_Gebinde: null,

        Palettenmenge: null,
        Palettennr: null,
        Umrpalgebinde: null,
        Umrpalmenge: 0,

        Chargenpflicht: 'N',
        Seriennrpflicht: 'N',

        Matchcode: position.ArtikelGruppe,
        GruppenBezeichnung: position.GruppeBezeichnung,

        // Auftrag
        Belegnr: this.BuchungNr,
        Datum: this.date,
        Name: '',

        Buchungen: [{
          Belegnr: position.BuchungNr,
          Posnr: position.PosNr,
          Menge: position.Menge,
          Gebindemenge: position.GebindeMenge ?? 0,
          AbgehendesLager: {
            Niederlassung: position.Niederlassung,
            Lagerhalle: position.Lagerhalle,
            Lagerfach: position.Lagerfach,
          },
        }],
        VerfuegbareNVEs: [],
        Chargen: [],
        Restmenge: position.Menge,
        Bediener: this.ErstelltDurch,
      };
    });
  }
}
